import { useState } from 'react';
import { User, Users, Baby, Check } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Mode Selector - Permet à l'organisateur de basculer entre modes
 * Organisateur peut tester TOUS les modes : Organisateur / Visiteur / Kids
 */
export default function ModeSelector({ currentRole, canSwitch, onSwitchMode }) {
  const [switching, setSwitching] = useState(false);

  if (!canSwitch) return null;

  const modes = [
    {
      id: 'organizer',
      name: 'Organisateur',
      icon: User,
      color: 'from-purple-500 to-pink-500',
      description: 'Vue complète, gestion totale'
    },
    {
      id: 'visitor',
      name: 'Visiteur',
      icon: Users,
      color: 'from-blue-500 to-cyan-500',
      description: 'Vue simplifiée, participant'
    },
    {
      id: 'kids',
      name: 'Enfant',
      icon: Baby,
      color: 'from-green-500 to-emerald-500',
      description: 'Mode ludique, gamifié'
    }
  ];

  const handleSwitch = async (modeId) => {
    if (modeId === currentRole) return;

    setSwitching(true);
    const success = await onSwitchMode(modeId);
    
    if (success) {
      toast.success(`Mode changé: ${modes.find(m => m.id === modeId).name}`);
    } else {
      toast.error('Erreur de changement de mode');
    }
    
    setSwitching(false);
  };

  return (
    <div className="flex items-center gap-2 bg-white rounded-xl p-2 shadow-sm border border-[#E2E8F0]" data-testid="mode-selector">
      <span className="text-xs text-[#64748B] px-2 hidden md:inline">Test Mode:</span>
      
      {modes.map((mode) => {
        const Icon = mode.icon;
        const isActive = currentRole === mode.id;
        
        return (
          <button
            key={mode.id}
            onClick={() => handleSwitch(mode.id)}
            disabled={switching || isActive}
            data-testid={`mode-btn-${mode.id}`}
            className={`
              flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium
              transition-all duration-200
              ${isActive 
                ? `bg-gradient-to-r ${mode.color} text-white shadow-md` 
                : 'text-[#64748B] hover:bg-[#F1F5F9]'
              }
              disabled:opacity-50
            `}
            title={mode.description}
          >
            <Icon className="w-4 h-4" />
            <span className="hidden sm:inline">{mode.name}</span>
            {isActive && <Check className="w-3 h-3" />}
          </button>
        );
      })}
    </div>
  );
}
